import {useEffect,useRef} from 'react';
import { useDispatch } from 'react-redux';
import BasePage from '../common/base';
import { PaymentContainer } from './payment.container';
import { BasePageStyles } from '../../hooks/styles';
import { Container } from '@mui/material';
const Payment = () => {
  const classes = BasePageStyles();
  const isFirstRender = useRef(true)
  const dispatch = useDispatch();
  useEffect(() => {
    isFirstRender.current = false
  }, [dispatch])

  return (
    <BasePage>
      <div className={classes.appBarSpacer}></div>
      <Container maxWidth={false} className={classes.container}>
        <PaymentContainer />
      </Container>
    </BasePage>
  )
}

export default Payment;